<template>
  <div>
    <el-dialog
      :visible="visible"
      :title="dialogTitle"
      width="666px"
      :close-on-click-modal="true"
      class="land-transfer-detail-dialog"
      @close="handleClose"
    >
      <div class="dialog-content">
        <!-- 左侧信息区域 -->
        <div class="info-section">
          <div class="info-item">
            <div class="info-label">地址</div>
            <div class="info-value">{{ detailInfo.address }}</div>
          </div>

          <div class="info-item">
            <div class="info-label">流转方/农户代表人</div>
            <div class="info-value">{{ detailInfo.transferParty }}</div>
          </div>

          <div class="info-item">
            <div class="info-label">面积（亩）</div>
            <div class="info-value">{{ detailInfo.area }}</div>
          </div>

          <div class="info-item">
            <div class="info-label">土地类型</div>
            <div class="info-value">{{ detailInfo.landType }}</div>
          </div>

          <div class="info-item">
            <div class="info-label">流转方式</div>
            <div class="info-value">{{ detailInfo.transferMethod }}</div>
          </div>

          <div class="info-item">
            <div class="info-label">期限（年）</div>
            <div class="info-value">{{ detailInfo.transferPeriod }}</div>
          </div>

          <div class="info-item amount-item">
            <div class="info-label">总金额（元）</div>
            <div class="info-value amount">{{ detailInfo.totalAmount }}</div>
          </div>
        </div>

        <!-- 右侧流转合同图片区域 -->
        <div class="contract-section">
          <div class="section-title">流转合同</div>
          <!-- 有合同图片时显示图片 -->
          <el-image
            v-if="detailInfo.contractImage"
            class="contract-image-container"
            :src="detailInfo.contractImage"
            :preview-src-list="detailInfo.contractImageList"
            fit="contain"
          ></el-image>
          <!-- 无合同图片时显示空状态 -->
          <div v-else class="no-contract-container">
            <img src="/imgs/默认文件.png" alt="暂无合同" class="no-contract-icon" />
            <div class="no-contract-text">暂无流转合同</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { selectContractPic } from '@/api/add'
import { getXmxxDetail } from '@/api/exchange'
export default {
  name: 'LandTransferDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    transferNo: {
      type: String,
      default: ''
    },
    xmbsm: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      photoBaseUrl: window.globalUrl.BASE_API + 'admin/file/get?ossFilePath=',
      dialogTitle: '',
      detailInfo: {
        // address: '北京市海淀区',
        // transferParty: '张三',
        // area: '50亩',
        // landType: '耕地',
        // transferMethod: '流转',
        // transferPeriod: '5年',
        // totalAmount: '¥150,000',
        // contractImage: '/admin/file/cqjy/register/202506/aa5135acad2148d295547ea58fafd234.jpeg',
        // contractImageList: ['/admin/file/cqjy/register/202506/aa5135acad2148d295547ea58fafd234.jpeg']
      }
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      }
    }
  },
  methods: {
    init() {
      this.dialogTitle = `流转详情：${this.transferNo}`
      this.loadData()
    },

    async loadData() {
      const res = await getXmxxDetail({ xmbh: this.transferNo })
      this.detailInfo = {
        address: res.data.xmdz || '',
        transferParty: res.data.crf || '',
        area: res.data.zcmj || '',
        landType: res.data.landType || '',
        transferMethod: res.data.turnType || 0,
        transferPeriod: res.data.lznx || '',
        totalAmount: res.data.gpjg || '',
        //这里必须先声明，否则不会显示图片,因为是异步操作！！！
        contractImage: '',
        contractImageList: []
      }

      const res1 = await selectContractPic({ xmbsm: this.xmbsm })
      if (res1.code === 0) {
        try {
          const picData = JSON.parse(res1.data.picUrl || '[]')

          if (Array.isArray(picData) && picData.length > 0) {
            // 直接处理图片URL
            this.detailInfo.contractImageList = picData
              .filter(item => item && item.imgUrl)
              .map(item => this.photoBaseUrl + item.imgUrl)

            this.detailInfo.contractImage = this.detailInfo.contractImageList[0] || ''
          }
        } catch (error) {
          console.error('解析图片数据失败:', error)
        }
      }
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
// 变量定义 - 从设计稿提取
@primary-color: #2563eb; // 主色调
@success-color: #16a34a; // 成功色（金额）
@text-primary: #1f2937; // 主文本色
@text-secondary: #6b7280; // 次要文本色

.land-transfer-detail-dialog {
  .el-dialog__header {
    padding: 25px 30px 20px;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.88);
      line-height: 30px;
    }

    .el-dialog__headerbtn {
      top: 22px;
      right: 25px;

      .el-dialog__close {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.45);

        &:hover {
          color: @primary-color;
          background-color: rgba(37, 99, 235, 0.1);
        }
      }
    }
  }

  .el-dialog__body {
    padding: 20px 30px 30px;
  }
}

.dialog-content {
  display: flex;
  gap: 30px;

  // 左侧信息区域
  .info-section {
    flex: 1;
    min-width: 0;

    .info-item {
      margin-bottom: 14px;

      .info-label {
        font-size: 17.7px;
        color: @text-secondary;
        line-height: 25.3px;
        margin-bottom: 5px;
      }

      .info-value {
        font-size: 17.7px;
        font-weight: 500;
        color: @text-primary;
        line-height: 27.8px;
      }

      &.amount-item {
        margin-top: 10px;

        .info-value.amount {
          font-size: 30.3px;
          font-weight: 700;
          color: @success-color;
          line-height: 40.5px;
        }
      }
    }
  }

  // 右侧合同图片区域
  .contract-section {
    flex: 1;
    min-width: 0;

    .section-title {
      font-size: 17.7px;
      color: @text-secondary;
      line-height: 25.3px;
      margin-bottom: 20px;
    }

    .contract-image-container {
      width: 100%;
      height: 400px;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      overflow: hidden;
    }

    // 无合同状态样式
    .no-contract-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 400px;
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      background-color: #fafafa;

      .no-contract-icon {
        width: 64px;
        height: 64px;
        margin-bottom: 12px;
        opacity: 0.6;
      }

      .no-contract-text {
        font-size: 14px;
        color: @text-secondary;
        text-align: center;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1024px) {
  .dialog-content {
    flex-direction: column;
    gap: 20px;

    .info-section {
      .info-item {
        margin-bottom: 20px;

        &.amount-item {
          .info-value.amount {
            font-size: 24px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .land-transfer-detail-dialog {
    .el-dialog__header {
      padding: 20px 20px 15px;

      .el-dialog__title {
        font-size: 18px;
      }
    }

    .el-dialog__body {
      padding: 15px 20px 25px;
    }
  }

  .dialog-content {
    .info-section {
      .info-item {
        .info-label,
        .info-value {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
